/* eslint no-unused-vars: ["error", { "argsIgnorePattern": "trackFunction" }] */
module.exports = {
    // See README for explanation of usage
    mockReactTracking: (trackFunction) => {
        return (target, _, descriptor) => {
            if (descriptor) {
                // TODO: Look into how this can be called with props, state and args as is done in actual react tracking decorator
                // or call as is but enforce that trackFunctions are mocked in tests
                // trackFunction();
                return descriptor;
            }
            return target;
        };
    },
};
